import * as Logger from 'js-logger';
import { ErrorHandling } from '../app';

export const setupDefaultLogger = () => {
  Logger.useDefaults();
};

export interface IWrapperLogger {
  info(msg: any): void;
  error(msg: string): void;
  debug(msg: string): void;
}

class LoggerWrapper implements IWrapperLogger {
  private loggerImpl: any;

  constructor(loggerImpl: any) {
    if (loggerImpl == null) {
      throw Error('Logger is not configured');
    }
    this.loggerImpl = loggerImpl;
  }

  public info(msg: any) {
    this.loggerImpl.info(msg);
  }

  public debug(msg: any) {
    this.loggerImpl.debug(msg);
  }

  public dir(msg: any) {
    this.loggerImpl.dir(msg);
  }

  public error(msg: string) {
    try {
      this.loggerImpl.error(msg);
      ErrorHandling.reportError(new Error(msg));
    } catch (e) {}
  }
}

export const logger = () => {
  return new LoggerWrapper(console);
};
